import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Collects an optional reason when declining a membership request (SC-301).
 *
 * The reason is shown to the person who was declined, which is the whole point of asking for it: a bare
 * refusal leaves somebody unable to work with no idea what to do next. It stays optional because forcing a
 * reason would only produce empty filler.
 */
@Component({
  selector: 'app-access-requests-decline-dialog',
  templateUrl: './access-requests-decline-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccessRequestsDeclineDialogComponent {
  reason: string = '';

  // Matches the API's max:500 validation rule, so the user is stopped here rather than by a 422.
  readonly maxLength: number = 500;

  constructor(
    public dialogRef: MatDialogRef<AccessRequestsDeclineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name?: string; count?: number }
  ) {}

  onConfirm(): void {
    // Closing with an object rather than the bare string keeps an empty reason distinguishable from a
    // cancelled dialog, which closes with undefined.
    this.dialogRef.close({ reason: (this.reason || '').trim() });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
